import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { useAnimatedScrollHandler, useSharedValue, } from 'react-native-reanimated';
import Modal from 'utils/packages/Modal';
import { useAppStore } from 'store/hooks';
import { selectUserId } from 'reducers/selectors';
import { rem } from 'design-system/values';
import PopUpMenuModal, { defaultPopUpWidth, } from 'design-system/PopUpMenuModal.web';
import { isCreditReportAccount } from 'utils/creditReportAccounts';
import AccountMenu from '../components/menu/AccountMenu';
import { isWeb } from '../../../constants';
import { PHYSICAL_ASSET_TYPES, getPropertyName } from '../constants';
export const useAccountMenu = (navigation, navigateBackAfterDelete = true) => {
    const store = useAppStore();
    const scrollValue = useSharedValue(0);
    const scrollHandler = useAnimatedScrollHandler((handle) => {
        scrollValue.value = handle.contentOffset.y;
    }, []);
    const openMenu = useCallback((account, touchViewRef) => {
        const userId = selectUserId(store.getState());
        if (userId !== account.userId) {
            return;
        }
        if (isCreditReportAccount(account)) {
            return;
        }
        let title = 'Account settings';
        if (account.provider === 'MANUAL') {
            title = 'Offline account settings';
        }
        if (account.isManual && PHYSICAL_ASSET_TYPES.has(account.type)) {
            title = `${getPropertyName(account.type)} settings`;
        }
        const content = (<AccountMenu account={account} navigation={navigation} navigateBackAfterDelete={navigateBackAfterDelete} onScroll={scrollHandler}/>);
        if (isWeb) {
            if (touchViewRef) {
                touchViewRef.current?.measure((_, __, ___, ____, fx, fy) => {
                    PopUpMenuModal.show(content, {
                        fx: fx - defaultPopUpWidth,
                        fy: fy + rem(40),
                        containerStyle: styles.containerStyles,
                    });
                });
            }
        }
        else {
            Modal.show(content, {
                title,
                containerStyle: styles.containerStyles,
                scrollable: {
                    maxHeight: 100,
                    scrollValue,
                },
            });
        }
    }, [scrollHandler, scrollValue]);
    return openMenu;
};
const styles = StyleSheet.create({
    containerStyles: {
        ...(isWeb
            ? {
                padding: 0,
                backgroundColor: 'transparent',
            }
            : {
                paddingHorizontal: 0,
            }),
    },
});
